import { getServerData } from 'js/src/libs/server-data';
import { hasFeatureEnabled } from 'js/src/libs/server-utils';
import type { DAMConfig } from 'js/src/typings/global';

const Flags = {
    canUseStaffControls: (): boolean => {
        return hasFeatureEnabled('staff_controls');
    },
    canSeeDamTab: (): boolean => {
        const damConfigs = getServerData()?.USER?.dam_configs;
        if (!damConfigs) {
            return false;
        }
        return damConfigs.some((damConfig: DAMConfig) => {
            if (damConfig.require_connection && damConfig.is_connected) {
                return true;
            }
            if (!damConfig.require_connection) {
                return true;
            }
            return false;
        });
    },
    canUseToolbox: () => {
        return hasFeatureEnabled('toolbox');
    },
    canUseBrandEnvironments: () => {
        return hasFeatureEnabled('brand_environments');
    },
    canUseVideoBriefs: () => {
        return Flags.canUseToolbox() && hasFeatureEnabled('video_briefs');
    },
    chatTabDeveloperToolsEnabled: () => {
        return hasFeatureEnabled('sketch_show_dev_details');
    },
    canUseScreenRecording: () => {
        return getServerData()?.USER?.capabilities?.screen_recording ?? true;
    },
    hideAllVideoCreationOptions: () => {
        return hasFeatureEnabled('hide_all_videos_creation_options');
    },
    canUseImproveMediaAgent: () => {
        return process.env.NODE_ENV !== 'test';
    },
    canUseTransitionSFX: () => {
        return hasFeatureEnabled('sound_effects_transition');
    },
    canUseCodeo: () => {
        return hasFeatureEnabled('codeo');
    },
    /**
     * The pieces of codeo rolled out on their own, each as a subagent: charts, layered graphics.
     * Codeo is the overarching flag, so it brings them too.
     */
    canUseCodeoSubagents: (): boolean => {
        return Flags.canUseCodeo() || hasFeatureEnabled('codeo_subagents');
    },
    /** Codeo authoring and the codeo subagents all make motion graphics scenes. */
    canUseMotionGraphicsScenes: (): boolean => {
        return Flags.canUseCodeoSubagents();
    },
    canUseCodeoBrand: () => {
        return hasFeatureEnabled('codeo_brand');
    },
    canSeeAllTemplates: () => {
        return hasFeatureEnabled('view_all_templates');
    },
    canUseDisclaimerText: () => {
        return hasFeatureEnabled('disclaimer_text');
    },
    canSeeDownloadMenuProductCallCta: () => {
        return hasFeatureEnabled('product_call_cta_download_menu');
    },
};

export default Flags;
